import React from 'react';
import { IconAlertCircle, IconRefresh, IconBulb, IconPlus } from '@tabler/icons-react';
import { useNavigate, useLocation } from 'react-router-dom';

export const ErrorMessage = ({ message, onRetry }) => (
  <div className="flex flex-col items-center justify-center p-8 text-center bg-white rounded-lg shadow-sm border border-red-100">
    <div className="w-12 h-12 rounded-full bg-red-50 flex items-center justify-center mb-4">
      <IconAlertCircle size={24} className="text-red-500" />
    </div>
    <h3 className="text-lg font-medium text-gray-900 mb-2">Something went wrong</h3>
    <p className="text-gray-600 mb-6 max-w-md">{message || 'An unexpected error occurred while loading solutions.'}</p>
    {onRetry && (
      <button
        onClick={onRetry}
        className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
      >
        <IconRefresh className="mr-2" size={16} />
        Try Again
      </button>
    )}
  </div>
);

export const LoadingState = () => (
  <div className="space-y-4">
    {[1, 2, 3].map((i) => (
      <div key={i} className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        <div className="p-4 border-b border-gray-100">
          <div className="animate-pulse flex space-x-4">
            <div className="rounded-full bg-gray-200 h-5 w-5"></div>
            <div className="flex-1 space-y-3 py-1">
              <div className="h-4 bg-gray-200 rounded w-3/4"></div>
            </div>
          </div>
        </div>
        <div className="p-4">
          <div className="animate-pulse space-y-3">
            <div className="h-3 bg-gray-100 rounded w-5/6"></div>
            <div className="h-3 bg-gray-100 rounded w-2/3"></div>
          </div>
        </div>
      </div>
    ))}
  </div>
);

export const EmptyState = ({ postId }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleAddSolution = (e) => {
    e.stopPropagation();
    e.preventDefault();

    navigate(`/solutions/${postId}/build`, {
      state: {
        from: location.pathname,
        scrollToPost: postId,
        shouldExpandSolutions: true
      },
      replace: false
    });
  };

  return (
    <div className="text-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-lg mx-auto">
        <div className="w-16 h-16 mx-auto rounded-full bg-green-50 flex items-center justify-center mb-4">
          <IconBulb size={32} className="text-green-500" />
        </div>
        <h3 className="text-lg font-medium text-gray-900 mb-2">No solutions yet</h3>
        <p className="text-gray-500 mb-6">
          Be the first to share your solution to this challenge. Your input could help others facing the same issue.
        </p>
        <button
          onClick={handleAddSolution}
          className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
        >
          <IconPlus className="mr-2" size={16} />
          Add a Solution
        </button>
      </div>
    </div>
  );
};
